
// ux_04_031
import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
  },
  mixins: [pdMixin],
  props: {
    dlvcPlcy: { // 배송정책
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
  },
  watch: {
    // visible (flag) {
    //   if (flag) {}
    // }
  },
  mounted () {
  },
  methods: {
    // 팝업 닫기
    close () {
      this.visible = false
    }
  }
}
